import { render, staticRenderFns } from "./BotSettings.vue?vue&type=template&id=c7f112b8&scoped=true"
import script from "./BotSettings.vue?vue&type=script&lang=ts"
export * from "./BotSettings.vue?vue&type=script&lang=ts"
import style0 from "./BotSettings.vue?vue&type=style&index=0&id=c7f112b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f112b8",
  null
  
)

export default component.exports